var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24272A",
    fillRule: "nonzero",
    d: "M20,3.75 C20,2.71875 19.15625,1.875 18.125,1.875 L18.5375,1.875 C17.9,0.75 16.7,0 15.3125,0 C13.925,0 12.725,0.75 12.0875,1.875 L12.5,1.875 C11.46875,1.875 10.625,2.71875 10.625,3.75 L10.625,5.625 L20,5.625 L20,3.75 Z M23.75,3.75 L21.875,3.75 L21.875,7.5 L8.75,7.5 L8.75,3.75 L6.875,3.75 C5.84375,3.75 5,4.59375 5,5.625 L5,28.125 C5,29.15625 5.84375,30 6.875,30 L23.75,30 C24.78125,30 25.625,29.15625 25.625,28.125 L25.625,5.625 C25.625,4.59375 24.78125,3.75 23.75,3.75 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.9a9386254b8ea4cd1021f2e0f3a1b0df.svg";
export { ForwardRef as ReactComponent };